import { Injectable } from '@angular/core';
import { AuthHttp } from 'app/infrastructure/common/index';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';
import { AppSettings } from 'app/infrastructure/settings/index';

@Injectable()
export class ProductUomService {

	constructor(
		private http: AuthHttp
	) { }

	getProductUomListByAll() {
		let params: URLSearchParams = new URLSearchParams();

		let options: RequestOptions = new RequestOptions({ search: params });
		return this.http.get(AppSettings.apiEndpoint + 'ProductUom/GetProductUomListByAll', options)
			.map((response: Response) => response.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/wm/product-uom.service.ts